document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const price = select.closest('[data-product-section]')?.querySelector('[data-product-price]');
      const option = select.options[select.selectedIndex];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });
  });
});